import { DefaultTheme, ScreenSizeBreakpoints } from 'styled-components';


const screenSizeWidthWithoutPx: Record<ScreenSizeBreakpoints, number> = {
  extraSmall: 576,
  small: 768,
  medium: 992,
  large: 1200,
  extraLarge: 1500,
  xExtraLarge: 1700,
};

// helper function to streamline modifying values of screenSizeWidth
function getScreenSizeWidthObject(): Record<ScreenSizeBreakpoints, string> {
  return Object.entries(screenSizeWidthWithoutPx).reduce<Record<ScreenSizeBreakpoints, string>>(
    (accumulator, [key, val]) => ({
      ...accumulator,
      [key as ScreenSizeBreakpoints]: `${val}px`,
    }),
    {} as Record<ScreenSizeBreakpoints, string>
  );
}

export const mainTheme: DefaultTheme = {
  // edit theme object here
  colors: {
    orange: '#F1945F',
    brown: '#926247',
    pink: '#FBDFD0',
    white: '#ffffff',
    black: '#000000',
    gray: '#535252',
    dark: '#282727',
    grayWithOpacity: 'rgba(50, 48, 48, 0.6)',
    placeholderGray: 'rgba(50, 48, 48, 0.4)',
    errorBackground: 'rgba(241, 148, 95, 0.3)',
  },
  fontSize: {
    extraSmall: '0.6rem',
    small: '0.94rem',
    medium: '1.125rem',
    large: '1.4rem',
    extraLarge: '1.5em',
  },
  headingSize: {
    small: '1.6rem',
    medium: '1.875rem',
    large: '2.2rem',
  },
  borderRadius: {
    medium: '12px',
  },
  screenSizeWidthWithoutPx,
  screenSizeWidth: getScreenSizeWidthObject(),
  tiles: {
    smallTile: 166,
    bigTile: 363,
  },
  navbarHeight: {
    mobile: '72px',
    desktop: '123px',
  },
};

